export const GET_NOTIFICATIONS = 'GET_NOTIFICATIONS';
export const LOAD_NOTIFICATIONS = 'LOAD_NOTIFICATIONS';
